import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
let agregoHallazgo = sessionStorage.getItem("agregoHallazgo");
if (
  agregoHallazgo === "true" &&
  window.location.pathname !== "/auditoria/agregarhallazgos" &&
  window.location.pathname !== "/auditoria/planInforme"
) {
  sessionStorage.setItem("agregoHallazgo", "false");
}
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
